import { Component, OnInit, Input} from '@angular/core';
import { GlobalLabels} from '../entities/global/model';

@Component({
    selector: 'breadcrumb-top',
    templateUrl: './breadcrumb-top.component.html',
    styleUrls: ['./breadcrumb-top.component.css']
})
export class BreadCrumbTopComponent {
    @Input() labels: GlobalLabels;
    constructor() {
    }
    ngOnInit() {
    }
}